import {http} from '@/axios'

function getInitState() {
  return {
    pendingVacancies: false,
    loadedVacancies: false,
    promiseVacanciesList: null,
    vacanciesList: [],
  }
}

export default {
  namespaced: true,
  state: getInitState(),
  mutations: {
    resetState(state) {
      Object.assign(state, getInitState())
    },
    setProperty(state, [key, value]) {
      if (!state.hasOwnProperty(key)) return
      state[key] = value
    }
  },
  actions: {
    load({commit, state}) {
      if (state.loadedVacancies) return Promise.resolve()

      if (state.pendingVacancies) {
        return state.promiseVacanciesList
      }

      commit('setProperty', ['pendingVacancies', true])

      const promiseVacanciesList = http.get('/api/feedback/vacancies').then(({data}) => {
        commit('setProperty', ['vacanciesList', data.data])
      }).finally(() => {
        commit('setProperty', ['loadedVacancies', true])
        commit('setProperty', ['pendingVacancies', false])
        commit('setProperty', ['promiseVacanciesList', null])
      })

      commit('setProperty', ['promiseVacanciesList', promiseVacanciesList])

      return promiseVacanciesList
    }
  }
}
